import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { useChartPeriod } from '@/hooks';
import { Flex, LineChart } from '@blockanalitica/ui';
import { ChartConfig } from '@blockanalitica/ui/package/types/src/components/charts/Chart';
import { useMemo, useState } from 'react';

export default function CapitalAtRiskHistoricGraph({ ilk }: { ilk: string }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi({
    url: `/groups/staked/ilks/${ilk}/at-risk-historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }
  const updateConfig: ChartConfig = useMemo(() => {
    return {
      options: {
        fill: false,
        plugins: {
          legend: {
            display: false
          }
        }
      }
    };
  }, []);
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod(updateConfig);

  const datasets = useMemo(() => {
    return [
      {
        label: '-20%',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        xField: 'date',
        yField: 'drop_20'
      },
      {
        label: '-30%',
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        xField: 'date',
        yField: 'drop_30'
      },
      {
        label: '-40%',

        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderColor: 'rgba(255, 99, 132, 1)',
        xField: 'date',
        yField: 'drop_40'
      }
    ];
  }, []);

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <LineChart
          data={data}
          datasets={datasets}
          timeFilter={timeFilter}
          config={config}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
